import {Tag} from 'api/types/tagTypes';
import {TagDTO} from 'api/typesDTO/tagDTO';

/**
 * Converts array of client side `Tag` objects to an array of
 * server-side `TagDTO` objects.
 * @param tags Array of tags to be converted to `TagDTO`.
 */
export function convertTagsToTagDTOArray(tags?: Tag[]): TagDTO[] {
  if (!tags) return [];
  return tags.map(t => ({id: t.id, name: t.name}));
}

/**
 * Converts array of server-side `TagDTO` objects to an array of
 * client-side `Tag` objects.
 * @param tagDTOArray Array of `TagDTO` objects to be converted to `Tag[]`
 */
export function convertTagDTOArrayToTags(tagDTOArray?: TagDTO[]): Tag[] {
  if (!tagDTOArray) return [];
  return tagDTOArray.map(tagDTO => {
    return {
      id: tagDTO.id,
      name: tagDTO.name,
    } as Tag;
  });
}
